import { AsyncStoreItem } from '@lib/store';
import { AmcJoiningInformationResponse } from 'src/sdk-servicing';

/**
 * PassAmcInformationState model
 */
export interface PassAmcInformationModel {
  model: AmcJoiningInformationResponse | null;
}

/**
 * PassAmcInformationStateResponse model details
 */
export interface PassAmcInformationStateDetails extends AsyncStoreItem {}

/**
 * PassAmcInformationState store state
 */
export interface PassAmcInformationState extends PassAmcInformationStateDetails, PassAmcInformationModel {}

/**
 * Name of the PassAmcInformationState Store
 */
export const PASS_AMC_INFORMATION_STORE_NAME = 'passAmcInformation';

/**
 * PassAmcInformationState Store Interface
 */
export interface PassAmcInformationStore {
  /** PassAmcInformationState state */
  [PASS_AMC_INFORMATION_STORE_NAME]: PassAmcInformationState;
}
